<ngb-alert class="always-on-top" *ngIf="showAlert" [type]="type" (close)="close()">{{ message }}</ngb-alert>
